import { render, staticRenderFns } from "./duke.vue?vue&type=template&id=6f600d20&"
import script from "./duke.vue?vue&type=script&lang=js&"
export * from "./duke.vue?vue&type=script&lang=js&"
import style0 from "./duke.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports